(function () {
    'use strict';

    angular.module('swif.openbase')
        .config(route);

    function route($routeProvider) {
        'ngInject';
        $routeProvider.when('/configuration/sites/table_view', {
            templateUrl: 'partials/openbase/sites_table_view.html',
            controller: OpenbaseSitesController,
            reloadOnSearch: false,
            resolve: {
                data: ['swifOpenbaseSiteService', function (service) {
                    return service.resolveData();
                }]
            }
        });
    }


    function OpenbaseSitesController($scope, openbase, data, goNetEndpointApi, swifOpenbaseCompanyService) {
        
        'ngInject';
        swifOpenbaseCompanyService.getGlobalSettings().then(function (company) {
            // checking if the company is Canadian if so we connect to GoNet
            $scope.is_canadian = company.is_canadian;
            if ($scope.is_canadian){
                goNetEndpointApi.getGoNetToken()
            }
        })
        $scope.sites = data.sites;
        $scope.callback = openbase.site.callback;
        $scope.preValidate = openbase.site.preValidate;
        $scope.preModal = openbase.site.preModal;
    }


})();
